export default "__VITE_ASSET__8213bbfe__"